<script>
export default {
  name: 'NoRmMessageLabel',
  props: ['isRmFound', 'isRmRequested'],
  methods: {
    isVisible: function () {
      return this.isRmRequested === true && this.isRmFound === false
    },
  },
}
</script>

<template>
  <span v-if="isVisible()" class="text-danger text-sm">
    <slot />
  </span>
</template>
